/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import PayrollSettlementARModalController from '../../Modals/ActionRequiredModals/PayrollSettlementARModal/PayrollSettlementARModalController';
import { useAppSelector } from '../../../infra/hooks';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import _ from 'lodash';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';
import i18n from '../../themes/i18n';

interface Propval {
  trans: any;
}

const PayrollSettlement = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});
  const [, setHistoryData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const getComplaintHistoryCall = (empId: any, companyId: any) => {
    actionRequiredService
      .getClaimHistory(empId, companyId)
      .then((result) => {
        setHistoryData(result?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleTransferView = (complaint: any) => {
    setFullData(complaint);
    getComplaintHistoryCall(complaint.emp_id, complaint.company_id);
  };

  const tableColumns: any = [
    {
      field: 'period',
      headerName: trans('Period'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <div style={{ display: 'flex' }}>
          <DateField
            value={params?.row?.startDate}
            format={baseDateFormatting}
          />{' '}
          {i18n.t('to')}{' '}
          <DateField value={params?.row?.endDate} format={baseDateFormatting} />
        </div>
      ),
    },
    {
      field: 'cutOffDate',
      headerName: trans('Cut Off Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.cutOffDate}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'startDate',
      headerName: trans('Start Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.startDate} format={baseDateFormatting} />
      ),
    },
    {
      field: 'endDate',
      headerName: trans('End Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.endDate} format={baseDateFormatting} />
      ),
    },

    {
      field: 'employees',
      headerName: trans('Employees'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      cutOffDate: data?.cutoff_date,
      startDate: data?.start_date,
      endDate: data?.end_date,
      employees: data?.payrole_instance?.settlement_details?.length,

      fullData: data,

      status: getStatus[data?.status],
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <PayrollSettlementARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default PayrollSettlement;
